module.exports = __webpack_public_path__ + "img/26.c68cdde6.jpg";